import {
  DefenseEventTypes,
  DefenseGenderTypes,
  DefenseRecordBeardTypes,
  DefenseRecordEmotionTypes,
  DefenseRecordEyesTypes,
  DefenseRecordGlassesTypes,
  DefenseRecordMaskTypes,
  DefenseRecordMouthTypes,
  IDefenseEventNotifyFacesProps,
} from '../../../../services/Defense/Events/types';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import React from 'react';
import {
  convertEventType,
  convertGenderType,
  convertRecordBeard,
  convertRecordEmotion,
  convertRecordEyes,
  convertRecordGlasses,
  convertRecordMask,
  convertRecordMouth,
} from '../../../../converters/Defense/ConverterDefense';
import dayjs from 'dayjs';
import DateFieldComponent from '../../../../components/DateFieldComponent';

interface NotifyFaceInfosContentProps {
  event: IDefenseEventNotifyFacesProps;
}

const DefenseNotifyFaceInfosContent = ({
  event,
}: NotifyFaceInfosContentProps) => {
  const formatCreatedAt = (date: Date) => {
    return dayjs(date, 'YYYY/MM/DD HH:mm:ss');
  };

  const formatDefenseDate = (date: Date) => {
    return dayjs(date);
  };

  // TODO: Criar tabela para visulizar faces similares e seus detalhes.

  return (
    <Grid2
      container
      direction={{ xs: 'column', lg: 'row' }}
      size={12}
      spacing={{ xs: 0, lg: 3 }}
      justifyContent={'center'}
      alignItems={{ xs: 'center', lg: 'normal' }}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora"
          value={formatCreatedAt(event.createdAt)}
          readOnly={true}
        />
        <TextFieldComponent
          label="ID do Canal"
          value={event?.channelId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora Captura"
          value={formatDefenseDate(event.appearTimes)}
          readOnly={true}
        />
        <TextFieldComponent
          label="Idade"
          value={event.recordAge ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Gênero"
          value={
            convertGenderType(event.recordGender as DefenseGenderTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Olhos"
          value={
            convertRecordEyes(event.recordEye as DefenseRecordEyesTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Boca"
          value={
            convertRecordMouth(event.recordMouth as DefenseRecordMouthTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Máscara"
          value={
            convertRecordMask(event.recordMask as DefenseRecordMaskTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Barba"
          value={
            convertRecordBeard(event.recordBeard as DefenseRecordBeardTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Óculos"
          value={
            convertRecordGlasses(
              event.recordGlasses as DefenseRecordGlassesTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Emoção do Rosto"
          value={
            convertRecordEmotion(
              event.recordEmotion as DefenseRecordEmotionTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora Início do Reconhecimento"
          value={formatDefenseDate(event.beginTime)}
          readOnly={true}
        />
        <DateFieldComponent
          label="Data/Hora Término do Reconhecimento"
          value={formatDefenseDate(event.endTime)}
          readOnly={true}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
    </Grid2>
  );
};

export default DefenseNotifyFaceInfosContent;
